var _pattern, _filter, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNftLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 60",
    width: 200,
    height: 60,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "primaryGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#6366f1",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#8b5cf6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#ec4899",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "secondaryGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#06b6d4",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#3b82f6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#8b5cf6",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "accentGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#f59e0b",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#ef4444",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#ec4899",
      stopOpacity: 1
    }
  })), _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    id: "blockchainPattern",
    x: 0,
    y: 0,
    width: 8,
    height: 8,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "none",
    stroke: "#6366f1",
    strokeWidth: 0.5,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 1,
    fill: "#6366f1",
    opacity: 0.6
  }))), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "glow",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10, 10)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "20,5 35,12.5 35,27.5 20,35 5,27.5 5,12.5",
    fill: "url(#primaryGradient)",
    stroke: "#6366f1",
    strokeWidth: 1.5,
    filter: "url(#glow)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 8,
    fill: "url(#secondaryGradient)",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 4,
    fill: "url(#accentGradient)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 12,
    x2: 20,
    y2: 28,
    stroke: "#06b6d4",
    strokeWidth: 1,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 20,
    x2: 28,
    y2: 20,
    stroke: "#06b6d4",
    strokeWidth: 1,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 1.5,
    fill: "#f59e0b"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 15,
    r: 1.5,
    fill: "#ef4444"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 25,
    r: 1.5,
    fill: "#ec4899"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 1.5,
    fill: "#06b6d4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50, 15)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 25,
    fontFamily: "Arial, sans-serif",
    fontSize: 20,
    fontWeight: "bold",
    fill: "url(#primaryGradient)"
  }, "\n      NFTxtreme\n    "))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 15,
    r: 2,
    fill: "url(#secondaryGradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 185,
    cy: 25,
    r: 1.5,
    fill: "url(#accentGradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175,
    cy: 35,
    r: 1,
    fill: "url(#primaryGradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNftLogo);
export default __webpack_public_path__ + "static/media/nft-logo.fb241a9f8c35bd5890856a2c1dcae2b2.svg";
export { ForwardRef as ReactComponent };